(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/shared/polling-mobile.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/shared/polling-mobile.js');


'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Fallback = svs.iam_idp.components.shared.Fallback;
const Button = svs.ui.Button;
const _React = React,
  useEffect = _React.useEffect;
const Loader = svs.components.ReactLoader.Loader;
const _jotai = jotai,
  useAtom = _jotai.useAtom,
  useAtomValue = _jotai.useAtomValue;
const _svs$iam_idp$atoms = svs.iam_idp.atoms,
  isPollingAtom = _svs$iam_idp$atoms.isPollingAtom,
  qrCodeAtom = _svs$iam_idp$atoms.qrCodeAtom,
  showLoaderAtom = _svs$iam_idp$atoms.showLoaderAtom,
  showFallbackAtom = _svs$iam_idp$atoms.showFallbackAtom,
  showFallbackQrAtom = _svs$iam_idp$atoms.showFallbackQrAtom;
const isPnp = svs.iam_idp.data.isPnp;
const QRCode = svs.components.libs.ReactQRCode;
const PollingMobile = () => {
  const _useAtom = useAtom(isPollingAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    isPolling = _useAtom2[0],
    setIsPolling = _useAtom2[1];
  const _useAtom3 = useAtom(showFallbackAtom),
    _useAtom4 = _slicedToArray(_useAtom3, 2),
    showFallback = _useAtom4[0],
    setShowFallback = _useAtom4[1];
  const _useAtom5 = useAtom(showFallbackQrAtom),
    _useAtom6 = _slicedToArray(_useAtom5, 2),
    showQr = _useAtom6[0],
    setShowQr = _useAtom6[1];
  const _useAtom7 = useAtom(showLoaderAtom),
    _useAtom8 = _slicedToArray(_useAtom7, 2),
    showLoader = _useAtom8[0],
    setShowLoader = _useAtom8[1];
  const qr = useAtomValue(qrCodeAtom);
  useEffect(() => {
    let timeout;
    setShowLoader(true);
    if (isPolling) {
      timeout = setTimeout(() => {
        setShowFallback(true);
        setShowLoader(false);
      }, 5000);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [isPolling, setShowFallback, setShowLoader]);
  const contentToRender = () => {
    if (showQr) {
      return React.createElement("div", {
        className: "iam-idp-qr-code-container"
      }, React.createElement(QRCode, {
        includeMargin: false,
        size: 120,
        value: qr
      }));
    } else if (showFallback) {
      return React.createElement(Fallback, null);
    } else if (showLoader) {
      return React.createElement("div", {
        className: "spinner-container"
      }, React.createElement("p", {
        className: "spinner-container-text"
      }, "V\xE4ntar p\xE5 identifiering i app"), React.createElement(Loader, {
        inverted: !isPnp
      }));
    }
    return null;
  };
  return React.createElement("div", null, contentToRender(), React.createElement(Button, {
    block: true,
    className: "",
    inverted: isPnp,
    onClick: () => {
      svs.accountservices.authenticate.login.cancel();
      setIsPolling(false);
      setShowFallback(false);
      setShowQr(false);
      setShowLoader(false);
    },
    size: 300,
    transparent: true
  }, "Avbryt"));
};
svs.iam_idp.components.shared.PollingMobile = PollingMobile;

 })(window);